module.exports = __webpack_public_path__ + "img/tow_0.d8f1afd4.png";